import { useContext } from "react";
import { ReportsContext } from "../contexts/ReportsContext";
import { IReportsContextProps } from "../types/interfaces/IReportsContextProps";

//This custom hook is responsible for consuming the reports context.
export function useReportsContext(): IReportsContextProps {
    const context = useContext(ReportsContext);

    if (!context) {
        throw new Error('The useReportsContext must be used within an ReportsProvider.');
    }

    return context;
}